export default __webpack_public_path__ + "static/media/banner-3.8f51ad18.jpg";